import bg from "../assets/bg.png";
import overlaybg from "../assets/overlaybg.png";
import sign from "../assets/sign.png";
import quote from "../assets/quote.png";
import chaeyeon_portrait from "../assets/chaeyeon_portrait.jpeg";
import myoja from "../assets/myoja.jpg";
import forest from "../assets/forest.jpg";
import Beach from "../assets/Beach.mp4";
import People from "../assets/People.jpg";
import Sky from "../assets/sky.jpg";
import Cardstock from "../assets/cardstock.jpeg";
import RecycledPaper from "../assets/recycledPaper.jpeg";
import SaltWaterPaperComparison from "../assets/saltwater_paper_comparison.jpeg";
import FreshWaterSaltWaterPaperComparison from "../assets/freshwater_saltwater_paper_comparison.jpeg";
import Jars from "../assets/jars.jpeg";
import OtherJars from "../assets/other_jars.jpeg";
import SaltwaterForkCorrosion from "../assets/saltwater_fork_corrosion.jpeg";
import FreshwaterForkCorrosion from "../assets/freshwater_fork_corrosion.jpeg";
import TreeBook from "../assets/tree_book.jpeg";
import MyjoaHiding from "../assets/myoja_hiding.jpeg";
import MyojaJumping from "../assets/myjoa_jumping.jpeg";
import Satelite from "../assets/satellite.jpeg";
import ConceptMyoja from "../assets/concept_myoja.jpeg";
import ConceptScenery from "../assets/concept_scenery.jpeg";

export default {
  bg,
  overlaybg,
  sign,
  quote,
  chaeyeon_portrait,
  myoja,
  forest,
  Beach,
  People,
  Sky,
  Cardstock,
  RecycledPaper,
  SaltWaterPaperComparison,
  FreshWaterSaltWaterPaperComparison,
  Jars,
  OtherJars,
  SaltwaterForkCorrosion,
  FreshwaterForkCorrosion,
  TreeBook,
  MyjoaHiding,
  MyojaJumping,
  Satelite,
  ConceptMyoja,
  ConceptScenery,
};
